export default "__VITE_ASSET__LNKjNgyF__"